import React from 'react';
import { MessageSquare } from 'lucide-react';

// ─── Props ───────────────────────────────────────────────────────────────────

export interface NoteBlockProps {
  /** Etiqueta del encabezado. Ej: "Nota de apertura", "Observaciones" */
  label: string;
  /** Contenido de la nota */
  content: string;
  /** Clase adicional para el contenedor raíz */
  className?: string;
}

// ─── Component ───────────────────────────────────────────────────────────────

export const NoteBlock: React.FC<NoteBlockProps> = ({
  label,
  content,
  className = '',
}) => {
  return (
    <div
      className={[
        'rounded-lg overflow-hidden',
        'bg-info-bg border border-info-border',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {/* Header */}
      <div
        className={[
          'flex items-center gap-1.5',
          'px-3 py-2',
          'border-b border-info-border',
        ].join(' ')}
      >
        <MessageSquare
          size={12}
          className="text-info flex-shrink-0"
          aria-hidden="true"
        />
        <span
          className={[
            'text-[10px] font-medium tracking-[0.08em] uppercase',
            'text-info',
          ].join(' ')}
        >
          {label}
        </span>
      </div>

      {/* Content */}
      <p className="px-3 py-2.5 text-ui-sm text-primary leading-relaxed text-left">
        {content}
      </p>
    </div>
  );
};

NoteBlock.displayName = 'NoteBlock';
